export default __webpack_public_path__ + "static/media/arm_tattoo.e0da73c9.jpg";